import { render, staticRenderFns } from "./saved-searches-subitem.vue?vue&type=template&id=4f1cf909"
import script from "./saved-searches-subitem.vue?vue&type=script&lang=ts"
export * from "./saved-searches-subitem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports